import { useCallback, useState } from 'react';

const CONTACTS_MIN_DISPLAY_AMOUNT = 3;

export const useShowMoreOrLess = (minDisplayAmount = CONTACTS_MIN_DISPLAY_AMOUNT) => {
  const [itemsDisplayAmount, setItemsDisplayAmount] = useState(minDisplayAmount);

  const isShowLessModeActive = checkIsShowLessModeActive(itemsDisplayAmount, minDisplayAmount);

  const toggleItemsDisplayAmount = useCallback(
    (items: unknown[]) => {
      setItemsDisplayAmount((prevState) => {
        const isShowLessActive = checkIsShowLessModeActive(prevState, minDisplayAmount);

        return isShowLessActive ? items.length : CONTACTS_MIN_DISPLAY_AMOUNT;
      });
    },
    [minDisplayAmount],
  );

  const processShowMoreOrLess = useCallback(
    <TItem>(items: TItem[]) => {
      return items.slice(0, itemsDisplayAmount);
    },
    [itemsDisplayAmount],
  );

  return { isShowLessModeActive, toggleItemsDisplayAmount, processShowMoreOrLess, minDisplayAmount };
};

function checkIsShowLessModeActive(fieldsAmount: number, minDisplayAmount: number) {
  return fieldsAmount === minDisplayAmount;
}
